import * as tslib_1 from "tslib";
import { DefaultButton } from 'office-ui-fabric-react/lib/Button';
import { Callout } from 'office-ui-fabric-react/lib/Callout';
import hidePersonaHeaderFirstRun from 'owa-favorites/lib/actions/v1/firstRun/markPersonaHeaderFirstRunCompleted';
import strings from 'owa-strings/owa-people-strings';
import { getPalette } from 'owa-theme';
import * as React from 'react';
import { logUsage } from 'owa-analytics';
import datapoints from '../datapoints';
var styles = require('./PersonaHeaderFirstRun.scss');
/**
 * Shows the first run experience the first time an user sees the PersonaHeader.
 */
var PersonaHeaderFirstRun = /** @class */ (function (_super) {
    tslib_1.__extends(PersonaHeaderFirstRun, _super);
    function PersonaHeaderFirstRun(props) {
        var _this = _super.call(this, props) || this;
        _this.popupDelay = 2000; // ms until the popup shows
        _this.onDismiss = function () {
            hidePersonaHeaderFirstRun();
            _this.setState({ isVisible: false });
        };
        _this.state = { delayTimerExpired: false, isVisible: true };
        return _this;
    }
    PersonaHeaderFirstRun.prototype.componentDidMount = function () {
        var _this = this;
        this.timer = setTimeout(function () {
            _this.setState({ delayTimerExpired: true });
            logUsage(datapoints.PersonaHeaderFREShown.datapoint.name);
        }, this.popupDelay);
    };
    PersonaHeaderFirstRun.prototype.componentWillUnmount = function () {
        this.cancelTimer();
    };
    PersonaHeaderFirstRun.prototype.render = function () {
        return (this.state.isVisible &&
            this.state.delayTimerExpired && (React.createElement(Callout, { backgroundColor: getPalette().themePrimary, className: styles.callout, gapSpace: 10, target: this.props.target, isBeakVisible: true, beakWidth: 15, setInitialFocus: false, onDismiss: this.onDismiss, directionalHint: 12 /* rightCenter */ },
            React.createElement("div", { className: styles.container },
                React.createElement("h1", { className: styles.title }, strings.firstRunExperienceHeader),
                React.createElement("p", { className: styles.content }, strings.firstRunExperienceContent),
                React.createElement(DefaultButton, { className: styles.button, text: strings.firstRunExperienceButton, onClick: this.onDismiss })))));
    };
    PersonaHeaderFirstRun.prototype.cancelTimer = function () {
        if (this.timer) {
            clearTimeout(this.timer);
        }
    };
    return PersonaHeaderFirstRun;
}(React.Component));
export default PersonaHeaderFirstRun;
//# sourceMappingURL=PersonaHeaderFirstRun.js.map